import api from "../../services/api";
import {
  ADD_SALARY_FAILURE,
  ADD_SALARY_REQUEST,
  ADD_SALARY_SUCCESS,
  GET_FILTERED_SALARIES_FAILURE,
  GET_FILTERED_SALARIES_REQUEST,
  GET_FILTERED_SALARIES_SUCCESS,
  RESET_SALARY,
} from "./ActionType";

const addSalaryRequest = () => {
  return {
    type: ADD_SALARY_REQUEST,
  };
};

const addSalarySuccess = (salary) => {
  return {
    type: ADD_SALARY_SUCCESS,
    payload: salary,
  };
};

const addSalaryFailure = (error) => {
  return {
    type: ADD_SALARY_FAILURE,
    payload: error,
  };
};

export const addSalary = (salary) => async (dispatch) => {
  dispatch(addSalaryRequest());
  try {
    const response = await api.post(`/salaries`, salary, {
      withCredentials: true,
    });
    dispatch(addSalarySuccess(response.data));
  } catch (error) {
    dispatch(addSalaryFailure(error.message));
  }
};

export const resetSalary = () => {
  return {
    type: RESET_SALARY,
  };
};

const getFilteredSalariesRequest = () => {
  return {
    type: GET_FILTERED_SALARIES_REQUEST,
  };
};

const getFilteredSalariesSuccess = (salaries) => {
  return {
    type: GET_FILTERED_SALARIES_SUCCESS,
    payload: salaries,
  };
};

const getFilteredSalariesFailure = (error) => {
  return {
    type: GET_FILTERED_SALARIES_FAILURE,
    payload: error,
  };
};
export const getFilteredSalaries = (filter) => async (dispatch) => {
  dispatch(getFilteredSalariesRequest());
  try {
    const response = await api.get(`/salaries/filter?${filter}`, {
      withCredentials: true,
    });
    dispatch(getFilteredSalariesSuccess(response.data));
  } catch (error) {
    dispatch(getFilteredSalariesFailure(error.message));
  }
};
